module.exports = " <div _v-1d3e288d=\"\"> <img class=\"img-circle avator\" :src=img :style=\"{width:size + 'px', height:size + 'px'}\" _v-1d3e288d=\"\"> <img class=\"pa v\" src=/assets/img/account/c@2x.png v-if=\"user.isCompanyUser || user.isCompanyAdmin\" _v-1d3e288d=\"\"> <img class=\"pa v\" src=/assets/img/account/v@2x.png v-if=isVip _v-1d3e288d=\"\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/template-rewriter.js?id=_v-1d3e288d!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./app/scaffold/avator.vue
// module id = 270
// module chunks = 0